import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../ResumeBuilding/RbPICurrentLocationNCordi.module.css'
import Geocode from "react-geocode";
import Select from 'react-select';
import { usePlacesWidget } from "react-google-autocomplete";
import { BASE_URL_API } from '../../../References/urls';
import AuthContext from '../../../store/auth-context';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const RbPICurrentLocationNCordi = props => {
     const authCtx = useContext(AuthContext)
    const [suggestions, setSuggestions] = useState([])
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [isChanging, setIsChanging] = useState(false)
    const [inputValue, setInputValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    let selectedUser = props.selectedUser;
    // console.log(selectedUser)
    const debounceRef = useRef(null);
    Geocode.setApiKey("AIzaSyB8zi0FbQWcuOpXbyy2OCpvMSkZbyv2A5U");
    Geocode.setLanguage("en");
    Geocode.setRegion("in");
    Geocode.setLocationType("ROOFTOP");

    const getCordinates = (value) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            if (!value || value.length < 3) {
                setSuggestions([]);
                setIsLoading(false);
                return;
            }

            setIsLoading(true);
            Geocode.fromAddress(value).then(
                (response) => {
                    console.log('Geocode API response:', response); // Debug log
                    console.log('Number of results:', response.results?.length); // Debug log
                    setSuggestions(response.results || []);
                    setIsLoading(false);
                },
                (error) => {
                    console.error('Geocode error:', error);
                    setSuggestions([]);
                    setIsLoading(false);
                }
            );
        }, 400);
    };

    const { ref } = usePlacesWidget({
        apiKey: 'AIzaSyB8zi0FbQWcuOpXbyy2OCpvMSkZbyv2A5U',
        onPlaceSelected: (place) => {
            console.log(place);
        },
        options: {
            types: ["(in)"],
            componentRestrictions: { country: "in" },
        },
    });

    const updateCandidateCurrentLocation = async (address) => {
            console.log("Updating current location");
            const updateCandidateCurrentLocationResponse = await fetch(BASE_URL_API + "/updateCandidateCurrentLocation",
                {
                    method: 'POST',
                    body: JSON.stringify({
                        token: authCtx.token,
                        stylist_id: selectedUser.stylist_id,
                        formattedAddress: address.formatted_address,
                        latitude: address.geometry.location.lat,
                        longitude: address.geometry.location.lng,
                        executiveIdentifier: authCtx.userIdentifier
                    })
                });
    
            if (!updateCandidateCurrentLocationResponse.ok) {
                console.log("Something went wrong : Server Error")
                toast.error("Server error, please try again!")
            } else {
                const updateCandidateCurrentLocationRespo = await updateCandidateCurrentLocationResponse.json();
                if (updateCandidateCurrentLocationRespo.status === "success") {
                    toast.success("Current location updated successfully")
                    setIsChanging(false);
                    setInputValue('');
                    setSuggestions([]);
                } else {
                    if (updateCandidateCurrentLocationRespo.message === "token Expired, please login again!") {
                        authCtx.logout();
                    } else {
                        toast.error("Could not update the current location, please try again!")
                    }
                }
                console.log(updateCandidateCurrentLocationRespo);
            }
        }
    
        const handleSelectChange = (option) => {
            if (option && option.value) {
                setSelectedAddress(option.value);
                updateCandidateCurrentLocation(option.value);
            }
        };
    
        const handleInputChange = (value, { action }) => {
            if (action === 'input-change') {
                setInputValue(value);
                getCordinates(value);
            }
        };


    const selectOptions = suggestions.map((item, index) => ({
        label: item.formatted_address,
        value: item,
        key: `${item.place_id || index}` // Unique key for each option
    }));


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.fieldTitle}>
                Current Location
            </div>
            <div className={styles.valueWrapper}>
                {isChanging ? (
                    <Select
                        placeholder="Type to search address..."
                        options={selectOptions}
                        onChange={handleSelectChange}
                        onInputChange={handleInputChange}
                        inputValue={inputValue}
                        isSearchable
                        isLoading={isLoading}
                        autoFocus
                        menuIsOpen={inputValue.length >= 3 && suggestions.length > 0}
                        noOptionsMessage={() =>
                            inputValue.length < 3
                                ? "Type at least 3 characters..."
                                : isLoading
                                    ? "Searching..."
                                    : "No addresses found"
                        }
                        filterOption={() => true} // Disable client-side filtering
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '40px'
                            }),
                            menu: (base) => ({
                                ...base,
                                maxHeight: '300px'
                            }),
                            menuList: (base) => ({
                                ...base,
                                maxHeight: '300px'
                            })
                        }}
                    />
                ) : (
                    <div className={styles.selectedAddressWrapper}>
                        <div className={styles.selectedAddressTxt}>
                            {selectedUser.currentLocation !== ''
                                ? selectedUser.currentLocation
                                : "Please update user's current location.."
                            }
                        </div>
                        <div
                            className={styles.changeBtn}
                            onClick={() => {
                                setIsChanging(true)
                                setSuggestions([])
                                setSelectedAddress(null)
                                setInputValue('')
                            }}
                        >
                            Update
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default RbPICurrentLocationNCordi